import {FixedDropDownButton, Icon} from 'mc/lib';
import * as PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {DropdownItem} from 'reactstrap';
import {
    showVratitHotoveModal,
    showVratitPrevodemModal,
    showVyrovnaniModal,
    vyraditZeZpracovani,
    zaraditDoZpracovani,
} from '../../actions/platbaActions';
import {
    isHlavickaPlatba,
    isVraceniEnabled,
    isVypisRadek,
    isVyrovnaniEnabled,
    isVyrovnaniNenulove
} from '../../utils/platbyUtils';
import * as authActions from "mc/lib/actions/authActions";
import * as appAuthActions from '../../actions/appAuthActions';
import * as PopRoleUzivatele from '../../api/gen/pop/PopRoleUzivatele';
import {MODULE_CODE_POP} from '../../utils/popUtils';
import {storeFromArea} from "mc/lib/utils";

class PlatbaActionsMenu extends PureComponent {

    /**
     * Načtení, zda je daný uživatel ma pravo na parovani plateb.
     * @param props
     * @return {boolean}
     */
    isParovaniPlateb = (props = this.props) => {
        const {authInfo} = props;
        if (authInfo.data == null) {
            return false;
        }
        return appAuthActions.hasRole(authInfo.data, MODULE_CODE_POP, PopRoleUzivatele.POP_PAROVANI_PLATEB);
    }

    static propTypes = {
        platba: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        readOnly: PropTypes.bool,
    };

    static defaultProps = {
        readOnly: false,
    };

    // componentDidMount() {
    //     const {dispatch} = this.props;
    //     dispatch(authActions.fetchAuthInfoIfNeeded());
    // }

    handleVyradit = () => {
        const {platba, dispatch} = this.props;
        dispatch(vyraditZeZpracovani(platba));
    };

    handleZaradit = () => {
        const {platba, dispatch} = this.props;
        dispatch(zaraditDoZpracovani(platba));
    };

    handleVratitPrevodem = () => {
        const {platba, dispatch} = this.props;
        dispatch(showVratitPrevodemModal(platba));
    };

    handleVratitHotove = () => {
        const {platba, dispatch} = this.props;
        dispatch(showVratitHotoveModal(platba));
    };

    handleNavigateToPlatba = () => {
        const {platba, history} = this.props;
        history.push('/platba/' + platba.id);
    };

    handleVyrovnat = () => {
        const {platba, dispatch} = this.props;
        dispatch(showVyrovnaniModal(platba, false, null));
    };

    render() {
        const {platba, readOnly} = this.props;
        const nenulovyBanVypisRadek = isVypisRadek(platba) && isVyrovnaniNenulove(platba);
        const isParovaniPlateb = this.isParovaniPlateb();
        return (
            <FixedDropDownButton title={<Icon icon="ellipsis-v"/>} color="action action-hover" noCaret>
                {isParovaniPlateb && !readOnly && !platba.vyrazeno && (
                    <DropdownItem onClick={this.handleVyradit}>Vyřadit</DropdownItem>
                )}
                {isParovaniPlateb && !readOnly && platba.vyrazeno && (
                    <DropdownItem onClick={this.handleZaradit}>Zařadit</DropdownItem>
                )}
                {isParovaniPlateb && !readOnly && isVraceniEnabled(platba) && (
                    <DropdownItem onClick={this.handleVratitPrevodem}>Vrátit převodem</DropdownItem>
                )}
                {isParovaniPlateb && !readOnly && isVraceniEnabled(platba) && isHlavickaPlatba(platba) && (
                    <DropdownItem onClick={this.handleVratitHotove}>Vrátit hotově / kartou</DropdownItem>
                )}
                {isParovaniPlateb && !readOnly && (isVyrovnaniEnabled(platba) || nenulovyBanVypisRadek) && (
                    <DropdownItem onClick={this.handleVyrovnat}>Vyrovnat</DropdownItem>
                )}
                <DropdownItem onClick={this.handleNavigateToPlatba}>Přehled vyrovnání</DropdownItem>
            </FixedDropDownButton>
        );
    }
}

const mapStateToProps = state => ({
    authInfo: storeFromArea(state, authActions.AUTH_INFO_AREA),
});

export default withRouter(connect(mapStateToProps)(PlatbaActionsMenu));
